<template>
  <button
    :id="btnId"
    ref="btn"
    type="button"
    :class="`btn btn-${color}`"
    style="min-width: 140px; font-size:20px; line-height:20px"
    :disabled="isLoading || disableButton"
    @click="(event) => setLoader(next, event)"
  >
    <div
      :class="{
        invisible: isLoading,
        'height-0': isLoading,
      }"
    >
      <slot>
        <div class="d-flex">
          <div
            class="m-auto position-relative"
            :class="{ 'px-3': icon !== null }"
          >
            {{ title }}
            <v-icon
              v-if="icon"
              :icon="icon"
              class="position-absolute"
              style="right: 0px;top:0;bottom:0"
            />
          </div>
        </div>
      </slot>
    </div>
    <div
      v-show="isLoading"
      class="text-center mx-auto"
    >
      <v-animation
        width="20"
        height="20"
        color="gray-300"
      />
    </div>
  </button>
</template>
<script>
import { debounce } from 'lodash-es';

import LoadingAnimation from '@/components/common/helpers/LoadingAnimation.vue';

export default {
  name: 'DefaultLoader',
  components: {
    'v-animation': LoadingAnimation,
  },
  props: {
    color: {
      type: String,
      required: false,
      default: 'primary',
    },
    btnId: {
      type: String,
      required: false,
      default: () => '',
    },
    title: {
      type: String,
      required: false,
      default: () => '',
    },
    callback: {
      type: Function,
      required: false,
      default: () => {},
    },
    icon: {
      type: [String, null],
      required: false,
      default: () => null,
    },
    focus: {
      type: Boolean,
      required: false,
      default: false,
    },
    disableButton: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    next: {
      type: Function,
      required: false,
      default: () => Promise.resolve(),
    },
    debounceTimer: {
      type: Number,
      required: false,
      default: 500,
    },
    forceLoader: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      debouncer: ({ cancel: () => {} }),
      isLoading: false,
    };
  },
  watch: {
    focus: {
      handler() {
        this.$refs.btn.focus();
      },
    },
    forceLoader: {
      handler(value) {
        this.isLoading = value;
      },
    },
  },
  methods: {
    setLoader(debounceFunction, event) {
      this.debouncer.cancel();
      this.isLoading = true;
      const toBeCalled = () => {
        debounceFunction(event)
          .catch((err) => {
            const currentPage = this.$route.path;
            this.$store.dispatch('reporting/sendError', { err, currentPage });
          })
          .then(() => { this.isLoading = false })
          .finally(() => {
            this.callback(!this.loading);
            this.$emit('isloaded', !this.isLoading);
          });
      };
      this.debouncer = debounce(
        toBeCalled,
        this.debounceTimer,
      );
      this.debouncer();
    },
  },
};
</script>
<style scoped>
.height-0 {
  height:0px!important;
}
</style>
<style lang="scss" scoped>
@use "@/assets/styles/animation.scss";
</style>
